import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_IMG_URL,
  headers: {
    "Content-type": "application/json"
  }
});

export default {
  auth(url = 'users') {
    return {
      login: (data) => http.post(url + '/authenticate', data),

      register: ({ email, name, password }) => http.post(url + '/register', { email, name, password })
    }
  },

  user(url = 'users') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, name = null, email = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&name=" + name + "&email=" + email, config),
      fetchById: id => http.get(url + "/" + id, config),
      create: newRecord => http.post(url + '/register', newRecord, config),
      update: (id, updatedRecord) => http.post(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getByUserName: id => http.get(url + "/getByUserName/" + id, config),

    }
  },

  room(url = 'rooms') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      getUnreadCount: () => http.get(url + '/getUnreadCount', config),
      fetchPagination: (page, limit = 50, userid = null, searchstring = null, params) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&userid=" + userid + "&searchstring=" + searchstring+ "&params=" + params, config),
      findPaginationWithSearch: (page, limit = 50, userid = null, searchstring = null, params) =>
        http.get(url + '/findPaginationWithSearch' + "?page=" + page + "&limit=" + limit + "&userid=" + userid + "&searchstring=" + searchstring+ "&params=" + params, config),
      fetchById: id => http.get(url + "/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
     // update: (updatedRecord) => http.put(url + "/update/" + updatedRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),

      delete: id => http.put(url + "/remove/" + id, {}, config),
      findidpdate: (id, updatedRecord) => http.post(url + "/findidpdate/" + id, updatedRecord, config),
    }
  },
  msg(url = 'msgs') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token'),
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, mobile = null, phone_number_id = null, type = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit + "&mobile=" + mobile + "&phone_number_id=" + phone_number_id+ "&type=" + type, config),
      fetchById: id => http.get(url + "/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      sendwsmsg: newRecord => http.post(url + '/sendwsmsg', newRecord, config),
      sendbotmsg: newRecord => http.post(url + '/bot_sendmsg', newRecord, config),
      gettemplates: (wa_business_id, token) => http.get('https://graph.facebook.com/v19.0/' + wa_business_id + '/message_templates?fields=name,status,components,language&limit=10', {
        headers: {
          'authorization': token
        }
      }),
      getproducts: (catalog_id, token, searchkeyword) => http.get('https://graph.facebook.com/v19.0/' + catalog_id + '/products?filter={name: {i_contains: "' + searchkeyword + '"}}', {
        headers: {
          'authorization': token
        }
      }),
      sendmedia: (file, msgsParam) => http.post(url + '/sendmedia', file, msgsParam, config),
    }
  },
  reminder(url = 'reminders') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      fetchAll: () => http.get(url + '/all', config),
      fetchPagination: (page, limit = 10, name=null, email = null) =>
        http.get(url + '/findPagination' + "?page=" + page + "&limit=" + limit+ "&name=" + name + "&email=" + email, config),
      fetchById: id => http.get(url + "/single/" + id, config),
      create: newRecord => http.post(url + '/addnew', newRecord, config),
      update: (id, updatedRecord) => http.put(url + "/update/" + id, updatedRecord, config),
      delete: id => http.put(url + "/remove/" + id, {}, config),
      getByTitle: id => http.get(url + "/getByTitle/" + id, config),
            getReminderByRoom: newRecord => http.post(url + '/getReminderByRoom', newRecord, config),

    }
  },
  utility(url = 'utility') {

    const config = {
      headers: {
        'authorization': 'Bearer ' + localStorage.getItem('token')
      }
    };

    return {
      upload: (file) => http.post(url + '/upload', file, config),
    }
  },
  notification() {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "key=AAAAM2TkNWk:APA91bET4-uzLsF2s_ola_KDhz4e_k0eJ4UZaF_U-DHWoC5d4d9DhSREGDoNE4eLl182OtQBvggUslpGycli1IzlASN2z0NF-rTmnX7iK7TMWOMyHG4yoUvJz3HB34EQYpMz0yVpHgoA"
      }
    };

    return {
      sendPushNotification: (notificationParam) => http.post('https://fcm.googleapis.com/fcm/send', notificationParam, config),
    }
  },

  tm(url = 'https://tm.alzaabigroup.com/api/user') {

    const config = {
   
    };
    return {
            GetUserTaskPendingSummaryByEmail: (email) => http.get(url + '/GetUserTaskPendingSummaryByEmail?email='+email, config)
    }
  },

}